import React from 'react';
import Link from 'next/link';
import IMenuItem from '../../../models/header/IMenuItem';
import styles from './mobile-navigation.module.scss';
import { ChevronDown } from '../../atoms/icons/icons';
import colorStyle from '../../../styles/utils/variables.module.scss';

export type MobileNavigationItemProps = {
  item: IMenuItem;
  translate: (key: string) => string;
  parentId: string;
  openMenus: Set<string>;
  toggleSubMenu: (id: string, isExpanded: boolean, parentId: string) => void;
  toggleMenu: () => void;
  onClick?: () => void;
};

const MobileNavigationItem: React.FC<MobileNavigationItemProps> = ({
  item,
  translate,
  parentId,
  openMenus,
  toggleSubMenu,
  toggleMenu,
  onClick,
}) => {
  const menuId = parentId
    ? `${parentId}-${(item.text || translate(item.translationKey))?.replace(/\s+/g, '-').toLowerCase()}`
    : (item.text || translate(item.translationKey))?.replace(/\s+/g, '-').toLowerCase();

  const isExpanded = openMenus.has(menuId);

  const handleToggle = () => toggleSubMenu(menuId, isExpanded, parentId);

  return (
    <li
      className={styles['mobile-navigation__nav__item']}
      onClick={item.children ? null : toggleMenu} // to close submenus/menus when clicking on a link
    >
      {item.children ? (
        <>
          <button
            type='button'
            className={`${styles['mobile-navigation__button']} ${
              isExpanded
                ? styles['mobile-navigation__button--open']
                : styles['mobile-navigation__button--close']
            }`}
            aria-expanded={isExpanded}
            onClick={handleToggle}
          >
            {item.text || translate(item.translationKey)}
            <span className={`${styles['mobile-navigation__button-chevron']}`}>
              <ChevronDown fillColor={colorStyle.white} height={18} width={16} />
            </span>
          </button>
          {isExpanded && (
            <div
              className={`${styles['mobile-navigation__submenu']} ${
                isExpanded
                  ? styles['mobile-navigation__submenu--open']
                  : styles['mobile-navigation__submenu--closed']
              }`}
            >
              <ul className={`${styles['mobile-navigation__nav__list']} p-0 m-0`}>
                {item.children.map((child) => (
                  <MobileNavigationItem
                    key={`${menuId}-${child.text || translate(child.translationKey)}`}
                    item={child}
                    translate={translate}
                    parentId={menuId}
                    openMenus={openMenus}
                    toggleSubMenu={toggleSubMenu}
                    toggleMenu={toggleMenu}
                    onClick={onClick}
                  />
                ))}
              </ul>
            </div>
          )}
        </>
      ) : (
        <Link href={item.url} className={styles['mobile-navigation__nav__link']}>
          {item.text || translate(item.translationKey)}
        </Link>
      )}
    </li>
  );
};

export default MobileNavigationItem;
